module.exports = __webpack_public_path__ + "static/media/logo1.2ebc9ef4.png";